import { useMutation } from "@tanstack/react-query"
import fetchData from "../fetcher"
import { GetPresignedUrlRequest, GetPresignedUrlResponse } from "./types"

const useGetPresignedUrl = () => {
    const { mutate: getPresignedUrl, mutateAsync: getPresignedUrlAsync, isPending: isGetPresignedUrlPending, isError } = useMutation({
        mutationKey: ["get-presigned-url"],
        mutationFn: (data: GetPresignedUrlRequest) => fetchData<GetPresignedUrlResponse>("/data/v4/files/get-pre-signed-url-for-upload", { method: "POST", body: data }),
    })
    return {
        getPresignedUrl,
        getPresignedUrlAsync,
        isGetPresignedUrlPending,
        isError
    }
}

export default useGetPresignedUrl
